var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66602 14.8335C6.94216 14.8335 7.16602 15.0574 7.16602 15.3335V16.6668C7.16602 16.8878 7.25381 17.0998 7.41009 17.2561C7.56637 17.4124 7.77834 17.5002 7.99935 17.5002H15.9993C16.2204 17.5002 16.4323 17.4124 16.5886 17.2561C16.7449 17.0998 16.8327 16.8878 16.8327 16.6668V15.3335C16.8327 15.0574 17.0565 14.8335 17.3327 14.8335C17.6088 14.8335 17.8327 15.0574 17.8327 15.3335V16.6668C17.8327 17.1531 17.6395 17.6194 17.2957 17.9632C16.9519 18.307 16.4856 18.5002 15.9993 18.5002H7.99935C7.51312 18.5002 7.0468 18.307 6.70299 17.9632C6.35917 17.6194 6.16602 17.1531 6.16602 16.6668V15.3335C6.16602 15.0574 6.38987 14.8335 6.66602 14.8335Z",
    fill: "#38393D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31246 10.9799C8.50772 10.7847 8.82431 10.7847 9.01957 10.9799L11.9993 13.9597L14.9791 10.9799C15.1744 10.7847 15.491 10.7847 15.6862 10.9799C15.8815 11.1752 15.8815 11.4918 15.6862 11.687L12.3529 15.0204C12.1576 15.2156 11.8411 15.2156 11.6458 15.0204L8.31246 11.687C8.1172 11.4918 8.1172 11.1752 8.31246 10.9799Z",
    fill: "#38393D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.1665C12.2761 6.1665 12.5 6.39036 12.5 6.6665V14.6665C12.5 14.9426 12.2761 15.1665 12 15.1665C11.7239 15.1665 11.5 14.9426 11.5 14.6665V6.6665C11.5 6.39036 11.7239 6.1665 12 6.1665Z",
    fill: "#38393D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.bedc459a17081f1fa90f60519db0aab4.svg";
export { ForwardRef as ReactComponent };